import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { faSnapchatSquare } from "@fortawesome/free-brands-svg-icons";
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons";
import { faTwitterSquare } from "@fortawesome/free-brands-svg-icons";

export default class footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <footer className="footer text-center pt-5 ">
          {/* bg-light */}
          <div className="container">
            <div className="row ">
              <div className="col-12 d-flex justify-content-center align-middle">
                <div className="sm">
                  <ul className="list-inline list-unstyled">
                    <li className="list-inline-item"><a href="#"> <FontAwesomeIcon icon={faPhoneSquare} size="2x" className="icon-footer" /></a></li>
                    <li className="list-inline-item"><a className="" href="#"> <FontAwesomeIcon icon={faInstagramSquare} size="2x" className="icon-footer" /></a></li>
                    <li className="list-inline-item"><a className="" href="#"> <FontAwesomeIcon icon={faSnapchatSquare} size="2x" className="icon-footer" /></a></li>
                    <li className="list-inline-item"><a className="" href="#"><FontAwesomeIcon icon={faTwitterSquare} size="2x" className="icon-footer" /></a></li>
                    <li className="list-inline-item"><a className="" href="#"><FontAwesomeIcon icon={faFacebookSquare} size="2x" className="icon-footer" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="clearfix w-100 d-md-none" />
          <div className="container text-center">
            <div className="row">
              <div className="col-12 col-md-12 text-center  mx-auto">
                <ul className=" list-group">
                  {/* list-md-inline */}
                  {/* <li className="list-inline-item mb-1"><a href="#" title=""> الخدمات</a></li>
            <li className="list-inline-item mb-1"><a href="#" title="">المبادرات </a></li>
            <li className="list-inline-item mb-1"><a href="#" title="/faq">الاسئلة الشائعة</a>
              </li>
              <li className="list-inline-item mb-1">
                <a href="/services#contactus" title="">تواصل معنا</a></li> */}
                  <li className="list-inline-item mb-1">
                    <a onClick={() => { window.location.href = "/services" }} className="nav-link" >
                      الخدمات
                  </a>
                  </li>
                  <li className="list-inline-item mb-1">
                    <a onClick={() => { window.location.href = "/initiatives" }} className="nav-link" >
                      المبادرات
                  </a>
                  </li>
                  <li className="list-inline-item mb-1">
                    <a onClick={() => { window.location.href = "/FAQ" }} className="nav-link" >
                      الاسئلة الشائعة

                  </a>
                  </li>
                  <li className="list-inline-item mb-1">
                    <a onClick={() => { window.location.href = "/services#contactus" }} className="nav-link" >
                      تواصل معنا

                  </a>
                  </li>

                </ul>
                <hr className="clearfix w-100 d-md-none" />
                <div className="copyright d-flex justify-content-center align-middle py-2">
                  <p className="text-center ">
                    جميع الحقوق محفوظة لهاد
                    © 2020
            </p>
                </div>
              </div>
              <a href="#" id="scroll" ><span></span></a>
              {/* style="display: none;" */}
            </div>
          </div>



        </footer>
      </>

    )
  }
}
